import { render, staticRenderFns } from "./introduceDetail.vue?vue&type=template&id=c808ff02&scoped=true&"
import script from "./introduceDetail.vue?vue&type=script&lang=js&"
export * from "./introduceDetail.vue?vue&type=script&lang=js&"
import style0 from "./introduceDetail.vue?vue&type=style&index=0&id=c808ff02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c808ff02",
  null
  
)

export default component.exports